document.addEventListener('DOMContentLoaded', function () {
  const menuItems = document.querySelectorAll('header-menu details');

  menuItems.forEach(function (details) {
    let timer;

    details.addEventListener('mouseenter', function () {
      clearTimeout(timer);
      this.setAttribute('open', '');
    });

    details.addEventListener('mouseleave', function () {
      const self = this;
      timer = setTimeout(function () {
        self.removeAttribute('open');
      }, 150);
    });
  });
});

// 滚动时导航变黑
window.addEventListener('scroll', function () {
  const header = document.querySelector('.section-header');
  if (!header) return;
  if (window.scrollY > 50) {
    header.classList.add('scrolled');
  } else {
    header.classList.remove('scrolled');
  }
});
